import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-cpay-step8",
	templateUrl: "./cpay-step8.component.html",
	styleUrls: ["./cpay-step8.component.scss"],
})
export class CpayStep8Component implements OnInit {
	@Input() allData;
	@Input() lastStepOpened;
	constructor() {}

	ngOnInit(): void {}
}
